import * as constants from './constants';

export const maintenanceInitialState = {
  periodicServices: null,
  services: null,
  allServices: null,
};

const periodicMaintenanceReducer = (
  state = maintenanceInitialState,
  { type, payload } = {},
) => {
  switch (type) {
    case constants.GET_PERIODIC_MAINTENANCE_DATA:
      return {
        ...state,
        periodicServices: payload,
      };
    case constants.GET_PERIODIC_MAINTENANCE_SERVICES:
      return {
        ...state,
        services: payload,
      };
    case constants.GET_PERIODIC_MAINTENANCE_ALL_SERVICES:
      return {
        ...state,
        allServices: payload,
      };
    case constants.RESET_PERIODIC_MAINTENANCE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default periodicMaintenanceReducer;
